module.exports = "pegasus_template/assets/blocks/tile-layout-01.png";